// extracted by mini-css-extract-plugin
module.exports = {"generic_information_wrapper":"_2TMPOK_vykcO7eYFCxTcOl"};